import { get, post, put } from "../Service/ApiConfig";
import { ApiEndpoints, UserEndPoint } from "../Service/Endpoints/ApiEndPoints";

export const createAdminUser = async ({ user }) => {
  const response = await post(UserEndPoint.createUser, JSON.stringify(user));
  return response;
};
export const resendResetPasswordLink = async ({ user }) => {
  const response = await post(
    UserEndPoint.resendPasswordLink,
    JSON.stringify(user),
  );
  return response;
};
export const getAdminUsers = async ({ page, size, searchText }) => {
  const response = await get(UserEndPoint.getUsers(page, size, searchText));
  return response;
};
export const isUserExisting = async ({ code }) => {
  const response = await get(UserEndPoint.isUserExisting(code));
  return response;
};

export const updateUserStatus = async ({ email, userCode, status }) => {
  const response = await put(
    UserEndPoint.updateUserStatus,
    JSON.stringify({ email, userCode, status }),
  );
  return response;
};

export const resetUserRetryCount = async (email) => {
  const response = await put(ApiEndpoints.resetUserRetryCount(email));
  return response;
}

export const updateUser = async ({ user }) => {
  const response = await put(UserEndPoint.updateUser, JSON.stringify(user));
  return response;
};
export const updateUserPassword = async ({ data }) => {
  const response = await put(
    UserEndPoint.updateUserPassword,
    JSON.stringify(data),
  );
  return response;
};
